import { User } from '@fund-base/types/auth/auth.types';
import { Fund } from '@fund-base/types/funds/funds.types';

export interface WorkPlanElement {
  id: number;
  //date?: Date;
  name?: string;
  funds?: number;
  submission_amount?: number;
  approved_amount?: number;
  transferred_amount?: number;
  status?: string;
  action?: string;
  moreOptions?: string;
  isSubmission?: boolean;
  displayed?: boolean;
  files?: string[];
  deadline?: Date;
  owner?: User;
  tasks?: WorkPlanTask[];
  submissions?: Submission[];
  created_at?: Date;
  fund?: Fund;
  currency?: string;
}

export interface WorkPlansFilter {
  name?: string;
}

export enum WorkPlansSortType {
  submission_amount = 'total_funding_amount',
  created_at = 'created_at',
  deadline = 'deadline',
}

export interface Submission {
  id?: number;
  name?: string;
  amount?: number;
  deadline?: Date;
  submission_amount: number;
  approved_amount: number;
  transferred_amount: number;
  status?: SubmissionStatus;
  work_plan?: WorkPlan;
  fund?: Fund;
  created_at?: Date;
  owner?: User;
  files?: string[];
  tasks?: WorkPlanTask[];
  currency?: string;
}

export enum SubmissionStatus {
  NOT_SUBMITTED = 'not submitted',
  SUBMITTED = 'submitted',
  APPROVED = 'approved',
  DECLINED = 'declined',
  PENDING_FILES = 'pending files',
}

export interface WorkPlan {
  id?: number;
  name?: string;
  deadline?: Date;
  total_funding_amount?: number;
  is_open?: boolean;
  owner?: User;
  submissions?: Submission[];
  created_at?: Date;
  submission_amount?: number;
  currency?: string;
  project_description?: string;
}

export class CreateWorkPlanDto {
  owner_email?: string;
  name?: string;
  deadline?: Date;
  total_funding_amount?: number;
  is_open?: boolean;
  currency?: string;
  project_description?: string;
}

export class UpdateWorkPlanDto {
  owner_email?: string;
  name?: string;
  deadline?: Date;
  total_funding_amount?: number;
  is_open?: boolean;
  workplan_id?: number;
  currency?: string;
  project_description?: string;
}

export class CreateTaskDto {
  name?: string;
  description?: string;
  status?: boolean;
  deadline?: Date;
  owner_email?: string;
  submission_id?: number;
  // Array of selected reminder offsets. undefined = not provided (legacy). [] means NO_EMAIL on backend.
  reminder?: string[];
}

export class UpdateTaskDto {
  name?: string;
  description?: string;
  status?: boolean;
  deadline?: Date;
  owner_email?: string;
  submission_id?: number;
  task_id?: number;
  reminder?: string[];
}

export class CreateSubmissionDto {
  name?: string;
  submission_amount?: number;
  approved_amount?: number;
  transferred_amount?: number;
  deadline?: Date;
  status?: SubmissionStatus;
  work_plan_id?: number;
  fb_id?: number;
  owner_id?: number;
  files?: string[];
  currency?: string;
}

export class UpdateSubmissionDto {
  submission_amount?: number;
  approved_amount?: number;
  transferred_amount?: number;
  deadline?: Date;
  status?: SubmissionStatus;
  tasksToDelete?: number[];
  owner_id?: number;
  submission_id?: number;
  files?: string[];
  currency?: string;
}

export interface WorkPlanTask {
  id: number;
  name: string;
  description: string;
  status: boolean;
  deadline: Date;
  owner: string;
  workplan_id?: number;
  // Comma-separated reminder offsets, e.g. '1d', '1d,1w'. null = no reminder set (UI defaults to 1d). 'NO_EMAIL' = opted out.
  reminder?: string | null;
}
